import { useMutation, useQueryClient } from 'react-query';
import useUploadStore from 'store/uploads/useUploadStore';

export function useSwitchRooftopMutation() {
  const queryClient = useQueryClient();
  return useMutation(async () => {
    await queryClient.invalidateQueries([], { refetchActive: true });
    queryClient.clear();
    await useUploadStore.getState().closeUppyInstances();
    await useUploadStore.getState().initialize();
  });
}
